import React, { useEffect, useState } from 'react';
import './NewYearTheme.css';

const NewYearTheme = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    // Check if theme should be active (until January 10, 2026)
    const now = new Date();
    const endDate = new Date('2026-01-10T23:59:59');
    setIsActive(now <= endDate);
  }, []);

  if (!isActive) return null;

  // Generate snowflakes with random properties
  const snowflakes = Array.from({ length: 50 }, (_, i) => {
    const style = {
      left: `${Math.random() * 100}%`,
      animationDuration: `${Math.random() * 3 + 8}s`,
      animationDelay: `${Math.random() * 5}s`,
      opacity: Math.random() * 0.6 + 0.2,
      fontSize: `${Math.random() * 10 + 10}px`
    };
    return (
      <div key={i} className="snowflake" style={style}>
        ❄
      </div>
    );
  });

  return (
    <div className="new-year-theme">
      <div className="snowfall-container">
        {snowflakes}
      </div>
      <div className="sparkle-overlay" />
    </div>
  );
};

export default NewYearTheme;
